import { dom } from './dom.js';
import { state } from './state.js';
import { THEMES } from './themes.js';

export const UI = {
  updateLayoutControls() {
    dom.workspace.classList.toggle('top-bottom', state.layout === 'top');
    dom.optSide.textContent = `${state.layout === 'side' ? '✓ ' : ''}Side by Side`;
    dom.optTop.textContent = `${state.layout === 'top' ? '✓ ' : ''}Top / Bottom`;
  },

  updateOptionControls() {
    dom.optTypes.textContent = `${state.showTypes ? '✓ ' : ''}Show JS Types`;
    dom.optIdx.textContent = `${state.showIdx ? '✓ ' : ''}Show Array Index`;
  },

  updateThemeControls() {
    if (!dom.themeMenu) return;
    dom.themeMenu.querySelectorAll('[data-action="set-theme"]').forEach((btn) => {
      const active = btn.dataset.theme === state.theme;
      btn.textContent = `${active ? '✓ ' : ''}${THEMES[btn.dataset.theme]?.label ?? btn.dataset.theme}`;
    });
  },

  openDropdown(targetId) {
    UI.closeDropdowns();
    const dropdown = document.getElementById(targetId);
    if (dropdown) dropdown.classList.add('open');
  },

  closeDropdowns() {
    document.querySelectorAll('.dropdown.open').forEach((dropdown) => {
      dropdown.classList.remove('open');
    });
  },

  showError(message = '') {
    if (message) {
      dom.errorBar.textContent = `⚠ ${message}`;
      dom.errorBar.classList.add('show');
    } else {
      dom.errorBar.textContent = '';
      dom.errorBar.classList.remove('show');
    }
  },

  renderEmptyState(message, isError = false) {
    dom.outputArea.replaceChildren();
    const span = document.createElement('span');
    span.className = isError ? 'error-text' : 'muted';
    span.textContent = message;
    dom.outputArea.appendChild(span);
  },

  resetPaneSize() {
    dom.inputPane.style.flex = '';
    dom.inputPane.style.width = '';
    dom.inputPane.style.height = '';
    dom.outputPane.style.flex = '';
  },
};
